// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1b901","subheader":"ReorderModal_subheader__2K1RD","listWrap":"ReorderModal_listWrap__3DZl7"};